import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'reactstrap';
import './DepartmentDetails.css';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import {
    Redirect
} from "react-router-dom";
import _ from 'lodash';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import RemoveEmployeeFromDepartmentModal from "../departmentModal/removeEmployeeFromDepartmentModal/RemoveEmployeeFromDepartmentModal.container";
import AddEmployeeToDepartmentModal from "../departmentModal/addEmployeeToDepartmentModal/AddEmployeeToDepartmentModal.container";
import { SUB_ROLES, SUB_ROLES_TRANSLATIONS } from '../../../reducers/account/role';
import EditDepartmentModal from "../departmentModal/editDepartmentModal/EditDepartmentModal.container";
import PageNotFoundComponent from '../../commonComponents/pageNotFoundComponent/PageNotFoundComponent.container';
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import FormWrapper from '../../commonComponents/formWrapper/FormWrapper.container';

const SUCCESS_MESSAGE_BY_ACTION = {
    ADD_STAFF: 'org_staff.departments.add_employee_to_department_success_message',
    REMOVE_STAFF: 'org_staff.departments.remove_employee_from_department_success_message',
    EDIT: 'org_staff.departments.edit_department_success_message'
}

class DepartmentDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            role: '',
            employeeToRemove: null,
            successMessage: null
        }
    }

    componentDidMount() {
        if (this.props.id !== this.props.pathId) {
            this.props.onDepartmentSet(this.props.pathId);
        }
        if (!_.isNil(this.props.id)) {
            this.props.onMount(this.props.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isNil(nextProps.id) && this.props.id !== nextProps.id) {
            this.props.onMount(nextProps.id);
        }
    }

    render() {
        if (_.isNil(this.props.pathId)) {
            return <Redirect to='/groups-management' push />
        }

        if (this.props.fetchingError) {
            return <PageNotFoundComponent />;
        }

        return (
            <div className='department-details-container'>
                <FormWrapper successMessage={_.get(this.props.translation, this.state.successMessage)}>
                    <BackButtonComponent path="/groups-management"
                                         label={_.get(this.props.translation, sharedLabelsPath.back_button)}/>
                    <h5 className='page-label'>{_.get(this.props.translation, sharedLabelsPath.department_label)}</h5>
                    {this.renderHeader()}
                    <div className={'department-employees-table-container'}>
                        <div className='department-table-label-container'>
                            <h6 className="font-weight-bold">{_.get(this.props.translation, 'org_staff.departments.employees_label')}</h6>
                            <span className='add-icon-container'>
                            <Button className="btn-sm olive-green-btn" onClick={this.handleAddButtonClick}>
                                {_.get(this.props.translation, sharedLabelsPath.add_button)}
                            </Button>
                        </span>
                        </div>
                        {this.renderContent()}
                    </div>
                    {this.renderModals()}
                </FormWrapper>
            </div>
        );
    }

    renderHeader = () => {
        if (!this.props.loading) {
            return (
                <div className='department-details-name-email-container'>
                    <div className='department-details-name-container'>
                        <h6>
                            <span className='department-name-container'>{_.get(this.props.translation, sharedLabelsPath.name_label)}: </span>
                            {this.props.data.name}
                        </h6>
                        <IconContainer
                            icon="create"
                            className='edit-department-icon'
                            onClick={this.handleEditDepartment}
                            title={_.get(this.props.translation, sharedLabelsPath.edit_button)}
                        />
                    </div>
                    <div className='department-details-email-container'>
                        <h6>
                            <span className='department-email-container'> {_.get(this.props.translation, sharedLabelsPath.email_label)}: </span>
                            {this.props.data.email}
                        </h6>
                        <IconContainer
                            icon="create"
                            className='edit-department-icon'
                            onClick={this.handleEditDepartment}
                            title={_.get(this.props.translation, sharedLabelsPath.edit_button)}
                        />
                    </div>
                </div>
            );
        }
    };

    renderContent = () => {
        if (this.props.loading) {
            return (
                <div className="department-employees-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || (this.props.data.hms.length === 0 && this.props.data.bos.length === 0)) {
            return (
                <div className="department-employees-status-message-container">
                    <h6>{_.get(this.props.translation, 'org_staff.departments.department_no_data_label')}</h6>
                </div>
            );
        }
        return (
            <Table className={'department-employees-table'}>
                <thead>
                    <tr>
                        <th>{_.get(this.props.translation, sharedLabelsPath.first_name_label)}</th>
                        <th>{_.get(this.props.translation, sharedLabelsPath.last_name_label)}</th>
                        <th>{_.get(this.props.translation, sharedLabelsPath.email_label)}</th>
                        <th>{_.get(this.props.translation, 'org_staff.departments.role_label')}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {this.getEmployeesDataByRole(SUB_ROLES.HM)}
                    {this.getEmployeesDataByRole(SUB_ROLES.BO)}
                </tbody>
            </Table>
        )
    };

    renderModals = () => {
        if (!this.props.loading) {
            return [
                <RemoveEmployeeFromDepartmentModal key='remove-employee-to-department-modal' departmentId={this.props.id}
                    data={this.state.employeeToRemove}
                    onCancelRemoving={this.handleCancelRemoving} />,
                <AddEmployeeToDepartmentModal key='add-employee-to-department-modal' departmentId={this.props.id}
                    staffMembersData={this.props.employees} hmList={this.props.data.hms.map(hm => hm.id)} boList={this.props.data.bos.map(bo => bo.id)} />,
                <EditDepartmentModal key='edit-department-modal' />
            ]
        }
    };

    getEmployeesDataByRole = (role) => {
        let employees = role === SUB_ROLES.HM ? this.props.data.hms : this.props.data.bos;

        return _.map(employees, employee => (
            <tr key={employee.id} className="department-employees-row">
                <td className='first-name-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.first_name_label) + ":"}>
                    {employee.identityAlias.firstName}
                </td>
                <td className='last-name-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.last_name_label) + ":"}>
                    {employee.identityAlias.lastName}
                </td>
                <td className='email-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.email_label) + ":"}>
                    {employee.email}
                </td>
                <td className='role-td'
                    data-th={_.get(this.props.translation, 'org_staff.departments.role_label') + ":"}>
                    {_.get(this.props.translation, 'roles.' + SUB_ROLES_TRANSLATIONS[role])}
                </td>
                <td className='control-cell'>
                    <IconContainer
                        key={employee.id}
                        icon="trash"
                        className="remove-from-department-icon"
                        title={_.get(this.props.translation, sharedLabelsPath.remove_button)}
                        onClick={this.handleRemoveButtonClick(employee, role)}
                    />
                </td>
            </tr>
        ));
    };

    componentWillUnmount() {
        this.props.onUnmount();
    }

    handleAddButtonClick = () => {
        this.props.onAddEmployeeToDepartment();
        this.props.onEmployeesLoad();
        this.setState({successMessage: SUCCESS_MESSAGE_BY_ACTION.ADD_STAFF});
    };

    handleRemoveButtonClick = (employee, role) => () => {
        this.setState({
            employeeToRemove: { role, ...employee },
            successMessage: SUCCESS_MESSAGE_BY_ACTION.REMOVE_STAFF
        });
        this.props.onRemoveEmployeeFromDepartment();
    };

    handleCancelRemoving = () => {
        this.setState({ employeeToRemove: null })
    };

    handleEditDepartment = () => {
        this.props.onEditDepartment();
        this.setState({successMessage: SUCCESS_MESSAGE_BY_ACTION.EDIT});
    }
}

DepartmentDetails.propTypes = {
    id: PropTypes.string,
    pathId: PropTypes.string,
    data: PropTypes.object,
    loading: PropTypes.bool,
    fetchingError: PropTypes.string,
    employees: PropTypes.array,
    translation: PropTypes.object,
    onMount: PropTypes.func,
    onEmployeesLoad: PropTypes.func,
    onEditDepartment: PropTypes.func,
    onAddEmployeeToDepartment: PropTypes.func,
    onRemoveEmployeeFromDepartment: PropTypes.func,
    onUnmount: PropTypes.func
};

export default DepartmentDetails;



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/departmentDetails/DepartmentDetails.js